import { useEffect, useState } from "react";
import { api, formatDate } from "@/api";
import { Activity, Shield, LogIn, LogOut, XCircle, CheckCircle2, ShieldOff, KeyRound } from "lucide-react";

const EVENT_META = {
  login: { label: "Giriş", icon: LogIn, tone: "success" },
  logout: { label: "Çıkış", icon: LogOut, tone: "info" },
  login_failed: { label: "Başarısız Giriş", icon: XCircle, tone: "danger" },
};

export default function ActivityPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/activity").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  const stats = items.reduce((acc, e) => {
    if (e.event === "login") acc.success++;
    else if (e.event === "login_failed") acc.failed++;
    return acc;
  }, { success: 0, failed: 0 });

  return (
    <>
      <div className="page-heading compact-heading">
        <div>
          <p className="eyebrow">Güvenlik / Aktivite</p>
          <h1>Giriş Geçmişi</h1>
          <p className="subheading">Şüpheli erişim var mı? Son 500 kimlik doğrulama olayını inceleyin.</p>
        </div>
      </div>

      <div className="summary-band">
        <div><span>Başarılı giriş</span><strong className="green-text">{stats.success}</strong></div>
        <div><span>Başarısız deneme</span><strong style={{color:"#f87171"}}>{stats.failed}</strong></div>
        <div><span>Toplam olay</span><strong>{items.length}</strong></div>
      </div>

      <div className="panel table-panel full-table">
        {loading ? <div className="loading-block">Yükleniyor…</div> :
          items.length === 0 ? (
            <div className="empty-state"><Activity size={30}/><h3>Henüz aktivite yok</h3><p>Kullanıcı giriş yaptıkça burada listelenecek.</p></div>
          ) : (
            <div className="data-table-wrap">
              <table data-testid="activity-table">
                <thead><tr>
                  <th>Zaman</th><th>Olay</th><th>E-posta</th><th>Durum</th><th>IP</th><th>Cihaz</th>
                </tr></thead>
                <tbody>
                  {items.map((e, i) => {
                    const meta = EVENT_META[e.event] || { label: e.event, icon: KeyRound, tone: "info" };
                    const Icon = meta.icon;
                    return (
                      <tr key={e.id || i} data-testid={`activity-row-${i}`}>
                        <td className="mono">{e.created_at?.slice(0,19).replace("T"," ")}</td>
                        <td><span className={`badge ${meta.tone}`}><Icon size={11} style={{marginRight:5, verticalAlign:"middle"}}/>{meta.label}</span></td>
                        <td className="bold-cell">{e.email || <span className="cell-muted">—</span>}</td>
                        <td>{e.success ? <span className="badge success">Başarılı</span> : <span className="badge danger">Başarısız</span>}{e.detail && <span className="cell-muted" style={{marginLeft:8, fontSize:10}}>{e.detail}</span>}</td>
                        <td className="mono">{e.ip || "—"}</td>
                        <td className="cell-muted" style={{fontSize:11, maxWidth:280, overflow:"hidden", textOverflow:"ellipsis"}}>{(e.user_agent || "—").slice(0, 40)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
      </div>
    </>
  );
}
